export default "__VITE_ASSET__7a975e1a__"